var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommandCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.82,
    height: 22.547,
    viewBox: "0 0 23.82 22.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.418,199.449a.627.627,0,1,0-.676-.625A.652.652,0,0,0,38.418,199.449Zm0,0",
    transform: "translate(-35.926 -189.792)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,134.966a2.112,2.112,0,0,0,1.985,2.215h19.85a2.112,2.112,0,0,0,1.985-2.215V120.535H0Zm13.944-10.73a.448.448,0,0,1,.421-.47h8.06a.448.448,0,0,1,.421.47v5.3a.447.447,0,0,1-.421.47h-8.06a.447.447,0,0,1-.421-.47Zm-7.978.7h6.257a.473.473,0,0,1,0,.94H5.966a.473.473,0,0,1,0-.94Zm0,4.19h6.257a.473.473,0,0,1,0,.94H5.966a.473.473,0,0,1,0-.94Zm0,4.191H22.448a.473.473,0,0,1,0,.94H5.966a.473.473,0,0,1,0-.94Zm-3.474-9.548a1.642,1.642,0,0,1,0,3.274,1.642,1.642,0,0,1,0-3.274Zm0,4.19a1.642,1.642,0,0,1,0,3.274,1.642,1.642,0,0,1,0-3.274Zm0,4.191a1.642,1.642,0,0,1,0,3.274,1.642,1.642,0,0,1,0-3.274Zm0,0",
    transform: "translate(0 -116.717)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.418,277.481a.627.627,0,1,0-.676-.625A.652.652,0,0,0,38.418,277.481Zm0,0",
    transform: "translate(-35.926 -263.737)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.278,40.516h0a.489.489,0,1,0,.489.489A.488.488,0,0,0,37.277,40.516Zm0,0",
    transform: "translate(-35.019 -40.548)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,40.777h0a.49.49,0,1,0,.49.49.49.49,0,0,0-.49-.49Zm0,0",
    transform: "translate(-115.977 -40.797)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.418,355.52a.627.627,0,1,0-.676-.625A.653.653,0,0,0,38.418,355.52Zm0,0",
    transform: "translate(-35.926 -337.475)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.835-2.082H1.985A1.987,1.987,0,0,0,0-.1V2.976H23.82V-.1A1.987,1.987,0,0,0,21.835-2.082ZM2.258,1.791h0a1.332,1.332,0,0,1,0-2.665h0a1.332,1.332,0,0,1,0,2.665ZM7.685.475A1.334,1.334,0,0,1,6.352,1.8h0a1.332,1.332,0,0,1,0-2.665h0A1.334,1.334,0,0,1,7.685.475Zm4.094.013a1.332,1.332,0,0,1-1.332,1.328h0a1.332,1.332,0,0,1,0-2.665h0A1.334,1.334,0,0,1,11.779.488Zm0,0",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.258,198.2h7.218v3.91h-7.218Zm0,0",
    transform: "translate(-292.472 -189.658)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.476,41.047h0a.49.49,0,0,0,0,.981h0a.49.49,0,0,0,0-.981Zm0,0",
    transform: "translate(-197.028 -41.053)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandCenter);
export default __webpack_public_path__ + "static/media/command-center.cf256cf03740bb7f2630b2809b08454c.svg";
export { ForwardRef as ReactComponent };